import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Media, Table } from 'reactstrap';
import { MoreHorizontal } from 'react-feather';
import { Link, useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { H5, Image, LI, P, UL } from '../../../AbstractElements';
import { NewsUpdate } from '../../../Data/DashDefault';
import { Today } from '../../../Constant';

const NewsUpdates = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage?.getItem("token");
  useEffect(() => {
    handle_get_firms();
  }, []);

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        `https://api-portal.nada.org.np/api/firms/metrics`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response2?.data?.success) {
        setData(response2?.data?.data?.firms);
        //setFirmOption(response2?.data?.data?.firm?.[0]?.status === 1? "Submitted" : response2?.data?.data?.firm?.[0]?.status === 2? "Send for Edits" : response2?.data?.data?.firm?.[0]?.status === 3? "Accepted" : response2?.data?.data?.firm?.[0]?.status === 4? "Rejected" : "Rejected");
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };

  return (
    <Fragment>
      <Col xl="4" md="6" className="dash-31 dash-xl-50 box-col-6">
        <Card className='news-update' style={{ minHeight: 213 }}>
          <CardHeader className="card-no-border">
            <div className="header-top">
              <H5 attrH5={{ className: 'm-0' }}>{t('Firm Updates')}</H5>
            </div>
          </CardHeader>
          <CardBody className="pt-0">
            <div className="table-responsive">
              <Table borderless>
               {/*<tbody>
                  {
                    data?.map((item) => {
                      if(item?.status_note !== null) {
                        return (
                          <tr key={item?.id}>
                            <td>
                              <Media>
                                <Media body>
                                <div onClick={() =>  {navigate('/firm/edit', { state: { id: item?.id } })}} style={{ cursor: 'pointer' }}>
                                    <H5>{t('New update to the firm')} {item?.name_of_firm}</H5>
                                  </div>
                                  <P>{item?.status_note}</P>
                                </Media>
                              </Media>
                            </td>
                            <td><span className="badge badge-light-theme-light font-theme-dark" style={{ color: '#2C6377 !important' }}>{item.time}</span></td>
                          </tr>
                        );
                      } else {
                        return null
                      }
                    })
                  }
                </tbody>*/}
                <tbody>
  {
    data
      ?.sort((a, b) => {
        // Check if `last_updated` exists; push items without it to the end
        console.log('last_updated', a.last_updated, b.last_updated);
        if (!a.last_updated) return 1;
        if (!b.last_updated) return -1;

        // Sort by `last_updated` (latest to oldest)
        return new Date(b.last_updated) - new Date(a.last_updated);
      })
      .map((item) => {
        if (item?.status_note !== null) {
          return (
            <tr key={item?.id}>
              <td>
                <Media>
                  <Media body>
                    <div
                      onClick={() => {
                        navigate('/firm/edit', { state: { id: item?.id } });
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <H5>{t('New update to the firm')} {item?.name_of_firm}</H5>
                    </div>
                    <P>{item?.status_note}</P>
                  </Media>
                </Media>
              </td>
              <td>
                <span
                  className="badge badge-light-theme-light font-theme-dark"
                  style={{ color: '#2C6377 !important' }}
                >
                  {item.time}
                </span>
              </td>
            </tr>
          );
        } else {
          return null;
        }
      })
  }
</tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default NewsUpdates;
